





























































import Vue from "vue";
import store from "@/store";
import { API } from "aws-amplify";
import { Constants } from "@/api-constants";

export default Vue.extend({
  name: "TeamCreate",

  components: {},

  props: {
    // status: {
    //   type: String,
    //   default: 'ok',
    //   required: false,
    //   validator: (value) => {
    //     return [
    //       'ok',
    //       'loading',
    //       'syncing',
    //       'synced',
    //       'version-conflict',
    //       'error'
    //     ].indexOf(value) !== -1
    //   }
    // },
  },

  data() {
    return {
      valid: false,
      dialog: false,
      vp_updating: false,
      message: '',
      showMessage: false,
      formSubject: '',
      ruleSubject: [
        (v: any) => !!v || '"Team Name" is required',
        (v: any) =>
          (v && v.length <= 100) ||
          '"Team Name" must be less than 100 characters'
      ],
      formBody: '',
      ruleBody: [
        // (v: any) => !!v || '"Description" is required',
        (v: any) =>
          ( !v || (v.length <= 500)) ||
          '"Description" must be less than 500 characters'
      ]
    };
  },

  created() {},

  mounted() {
  },

  updated() {
    // console.log(this.$refs.form);
  },

  watch: {
    isUpdating(newVal, oldVal) {
      console.log("[ TEAM CREATE ]: oldVal-" + oldVal + " newVal-" + newVal);
      if (!newVal && this.message == '') {
        this.message = '';
        this.dialog = false;
        this.clearForm();
      }
    },
    errorMessage(newVal, oldVal) {
      if (newVal != '') {
        this.message = newVal + '<br />Please try again in a few minutes.';
      }
    },
    dialog(newVal, oldVal) {
      if (!newVal) {
        // this.clearForm();
        this.message = '';
      }
    },
    // routeName(newVal, oldVal) {
    //   if (newVal === 'mls') {
    //     this.showFavourites = false;
    //   }
    //   if (newVal === 'favourites') {
    //     this.showFavourites = true;
    //   }
    // },
  },

  computed: {
    isValid(): boolean {
      return (this.valid && !!this.formSubject);
    },
    isUpdating(): any {
      return this.$store.getters.getVpUpdating;
    },
    isError(): boolean {
      return !!this.$store.getters.getVpErrorMessage;
    },
    errorMessage(): string {
      return this.$store.getters.getVpErrorMessage;
    },
    isLoggedIn(): any {
      return this.$store.getters.getIsLoggedIn;
    },
    thisForm(): Vue & { reset: () => void } {
      return this.$refs.form as Vue & { reset: () => void };
    },
  },

  methods: {
    teamCreate() {
      if (this.formSubject) {
        this.message = 'Your team is being created ...';
        // this.showMessage = true;
        let body: any = {
          name: this.formSubject
        };
        if (this.formBody) {
          body.description = this.formBody;
        }
        store.dispatch("createTeam", body);
      }
    },

    clearForm(): void {
      this.thisForm.reset();
    },

  }
});
